import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { Group, GroupService } from '@klickdata/core/group';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-add-users-into-group',
    templateUrl: './add-users-into-group.component.html',
    styleUrls: ['./add-users-into-group.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddUsersIntoGroupComponent implements OnInit, OnDestroy {
    public assignForm: FormGroup;
    public destroy: Subject<boolean> = new Subject<boolean>();
    public saving: boolean;

    constructor(
        public bottomSheetRef: MatBottomSheetRef<AddUsersIntoGroupComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
        protected fb: FormBuilder,
        protected groupService: GroupService
    ) {}

    ngOnInit() {
        this.assignForm = this.fb.group({
            id: [],
            sync_all: [],
            attach_ids: [[]],
            detach_ids: [[]],
        });
        this.assignForm.patchValue({ id: this.data.id });
    }

    public submit() {
        if (
            this.assignForm.value.sync_all !== null ||
            this.assignForm.value.attach_ids?.length ||
            this.assignForm.value.detach_ids?.length
        ) {
            const data = this.prepareData();
            this.saving = true;
            this.groupService
                .update(data)
                .pipe(takeUntil(this.destroy))
                .subscribe(() => {
                    this.saving = false;
                    this.bottomSheetRef.dismiss(this.data);
                });
        } else {
            this.bottomSheetRef.dismiss();
        }
    }
    private prepareData() {
        let users = this.assignForm.value;
        delete users.id;

        return { id: +this.data.id, users: users };
    }

    public ngOnDestroy() {
        this.destroy.next(true);
        this.destroy.unsubscribe();
    }
}
